import React, { useEffect } from 'react';
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase/config';
import { updateisLoginStatus } from '../Api';  // Importing the API function

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const confirmAndLogout = async () => {
      const confirmed = window.confirm('Are you sure you want to log out?');
      if (!confirmed) {
        navigate(-1); // Go back to previous page
        return;
      }

      const userId = localStorage.getItem('loggedInUserId');

      if (userId) {
        try {
          // Update isLoggedIn to 0 for the user when logging out
          await updateisLoginStatus(userId, 0);

          // Proceed with logging out from Firebase
          await signOut(auth);
          localStorage.removeItem('loggedInUserId');
          alert('You have been logged out.');
          navigate('/login');
        } catch (error) {
          console.error('Logout failed:', error);
          alert('Logout failed: ' + error.message);
        }
      } else {
        console.error('No user found in localStorage');
        alert('No user session found.');
      }
    };

    confirmAndLogout();
  }, [navigate]);

  // Disable right-click and common inspect shortcuts
  useEffect(() => {
    const handleContextMenu = (e) => e.preventDefault();
  
    const handleKeyDown = (e) => {
      if (e.key === 'F12') {
        e.preventDefault();
        return false;
      }
      if (
        (e.ctrlKey || e.metaKey) && 
        (e.shiftKey && ['I', 'J', 'C', 'K'].includes(e.key.toUpperCase()))
      ) {
        e.preventDefault();
        return false;
      }
      if (
        (e.ctrlKey || e.metaKey) &&
        ['U', 'S', 'P'].includes(e.key.toUpperCase())
      ) {
        e.preventDefault();
        return false;
      }
    };
  
    window.addEventListener('contextmenu', handleContextMenu);
    window.addEventListener('keydown', handleKeyDown);
  
    return () => {
      window.removeEventListener('contextmenu', handleContextMenu);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);


  return null;
};

export default Logout;
